var _circle, _circle2, _circle3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSetDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38 86.4286C38 82.9464 40.8073 80 44.4167 80H46.5556V97.1429H106.444V80H108.583C112.059 80 115 82.9464 115 86.4286V99.2857C115 102.902 112.059 105.714 108.583 105.714H44.4167C40.8073 105.714 38 102.902 38 99.2857V86.4286Z",
    fill: "url(#paint0_linear_6669_107722)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.833 52.4286C50.833 48.9464 53.6403 46 57.2497 46H95.7497C99.2254 46 102.166 48.9464 102.166 52.4286V93.1429H50.833V52.4286ZM92.675 58.7232C91.3382 57.5179 89.333 57.5179 88.1299 58.7232L73.2913 73.5893L67.0084 67.2946C65.6715 66.0893 63.6663 66.0893 62.4632 67.2946C61.1264 68.6339 61.1264 70.6429 62.4632 71.8482L71.0188 80.4196C72.2219 81.7589 74.2271 81.7589 75.5639 80.4196L92.675 63.2768C93.8781 62.0714 93.8781 60.0625 92.675 58.8571V58.7232Z",
    fill: "url(#paint1_linear_6669_107722)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6669_107722",
    x1: 76.5,
    y1: 45.7148,
    x2: 76.5,
    y2: 105.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6669_107722",
    x1: 76.5,
    y1: 46,
    x2: 76.5,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSetDefault);
export default __webpack_public_path__ + "static/media/img_set_default.9c57501636c893cac4097cedc6477d34.svg";
export { ForwardRef as ReactComponent };